import { Link as StyledLink } from "react-router-dom";

import styled from "@emotion/styled";

export const CardItem = styled.li`
  display: flex;
  flex-direction: column;

  //height: 223px;
  padding: ${p => p.theme.space[6]}px;

  background-color: ${p => p.theme.colors.white};
  border-radius: ${p => p.theme.radii.normal};

  //@media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
  //height: 232px;
  //}
`;

export const ArticleTitle = styled.p`
  margin-bottom: ${p => p.theme.space[5]}px;
  font-size: ${p => p.theme.fontSizes.l};
  font-weight: ${p => p.theme.fontWeight.medium};

  color: ${p => p.theme.colors.black};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.xl};
  }
`;

export const ArticleDescription = styled.p`
  margin-bottom: 20px;

  font-size: ${p => p.theme.fontSizes.s};
  line-height: 150%;
  color: ${p => p.theme.colors.secondary.gray};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-bottom: 28px;
    -webkit-line-clamp: 3;
  }
`;

export const Link = styled(StyledLink)`
  display: inline-flex;
  gap: ${p => p.theme.space[3]}px;
  padding: 5px 12px;
  margin-top: auto;
  width: fit-content;

  background-color: ${p => p.theme.colors.background};
  font-size: ${p => p.theme.fontSizes.m};
  color: ${p => p.theme.colors.black};
  text-decoration: none;
  border-radius: 7px;
  transition: background-color 0.3s ease-in-out;

  -webkit-tap-highlight-color: transparent;

  :hover {
    background-color: ${p => p.theme.colors.buttonHover};
  }

  :active {
    background-color: ${p => p.theme.colors.buttonActive};
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    padding: 12px 14px;
    border-radius: ${p => p.theme.radii.medium};
  }
`;
